define([
	"./_TextAlignVertical",
	"./PluginFactory"
], function(_TextVerticalAlign,PluginFactory) {

	return PluginFactory.declare(_TextVerticalAlign, {
		"class": "csi-button-toggle",
		cssValue: "center",
		materialIcon: "vertical_align_center",
		pluginName: "verticalCenter",
		title: "CanvasAlignTextVerticalCenter"
	});
});
